import Button from '@alltrails/shared/denali/components/Button';
import { defineMessages, FormattedMessage } from '@alltrails/shared/react-intl';
import { MEDIA_QUERY_MOBILE_DOWN } from 'utils/constants/breakpoints';
import { wrapUrlSafe } from 'utils/language_support_util';
import useFormatMessage from '@alltrails/shared/hooks/useFormatMessage';
import useUser from 'hooks/useUser';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import * as styles from './styles/styles.module.scss';
import headerImgSrc from '../../../../assets/images/welcome/header/couple-and-dog.jpg';
import headerImgSrcWebp from '../../../../assets/images/welcome/header/couple-and-dog.webp';
import headerImgSrcAvif from '../../../../assets/images/welcome/header/couple-and-dog.avif';
import headerImgMobileSrc from '../../../../assets/images/welcome/header/couple-and-dog-mobile.jpg';
import headerImgMobileSrcWebp from '../../../../assets/images/welcome/header/couple-and-dog-mobile.webp';
import headerImgMobileSrcAvif from '../../../../assets/images/welcome/header/couple-and-dog-mobile.avif';

const WelcomeHeader = () => {
  const user = useUser();
  const languageRegionCode = useLanguageRegionCode();
  const WELCOME_HEADER_STRINGS = defineMessages({
    IMAGE_ALT: {
      defaultMessage: 'A couple on a hike with their dog.'
    },
    TRY_PLUS_BUTTON: {
      defaultMessage: 'Try AllTrails+ free'
    }
  });
  const {
    formattedDefaultMessages: { IMAGE_ALT, TRY_PLUS_BUTTON }
  } = useFormatMessage(WELCOME_HEADER_STRINGS);

  return (
    <div className={styles.container}>
      <picture>
        <source media={MEDIA_QUERY_MOBILE_DOWN} srcSet={headerImgMobileSrcAvif} type="image/avif" />
        <source media={MEDIA_QUERY_MOBILE_DOWN} srcSet={headerImgMobileSrcWebp} type="image/webp" />
        <source media={MEDIA_QUERY_MOBILE_DOWN} srcSet={headerImgMobileSrc} type="image/jpg" />
        <source srcSet={headerImgSrcAvif} type="image/avif" />
        <source srcSet={headerImgSrcWebp} type="image/webp" />
        <img src={headerImgSrc} alt={IMAGE_ALT} className={styles.image} />
      </picture>
      <div className={styles.innerContainer}>
        <h1 className={styles.header}>
          <FormattedMessage defaultMessage="All your local trails in one app" />
        </h1>
        <p className={styles.description}>
          <FormattedMessage defaultMessage="Find walking paths near you with AllTrails, your companion that leads the way outside. Try AllTrails+ for extra tools like offline maps and more." />
        </p>
        <Button
          text={TRY_PLUS_BUTTON}
          linkInfo={{
            href: user
              ? wrapUrlSafe('/plus/checkout?ref=welcome_header', languageRegionCode)
              : wrapUrlSafe('/signup?returnTo=/plus/checkout&ref=welcome_header', languageRegionCode)
          }}
          testId="welcome-header-try-pro"
          variant="primary"
        />
        <span className={styles.disclaimer}>
          <FormattedMessage defaultMessage="Try AllTrails+ for free for 7 days" />
        </span>
      </div>
    </div>
  );
};

export default WelcomeHeader;
